import React from 'react';
import { graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import {
  brandColours,
  fontSize,
  fontWeights,
  minBreakpointQuery,
  standardColours,
} from '../styles';
import { Heading, Link } from './ui';

const StyledBlogCard = styled.article``;

const StyledItem = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  overflow: hidden;
`;

const StyledImage = styled(GatsbyImage)`
  overflow: visible;
  margin-bottom: -15px;

  img {
    border-radius: 20px;
  }
`;

const StyledContent = styled.div`
  padding: 30px;
  background-color: ${standardColours.white};
  border: solid 1px ${standardColours.grey};
  border-top: none;
  border-radius: 0 0 20px 20px;
  height: 100%;
  display: flex;
  flex-direction: column;

  ${minBreakpointQuery.small`
    padding: 35px;
  `}

  ${minBreakpointQuery.large`
    padding: 40px;
  `}
`;

const StyledOverline = styled.p`
  ${fontSize(18)};
  color: ${brandColours.secondary};
  padding-bottom: 20px;
  border-bottom: solid 1px ${standardColours.grey};

  ${minBreakpointQuery.small`
    padding-bottom: 25px;
  `}
`;

const StyledHeading = styled.h3`
  margin-top: 20px;
  font-weight: ${fontWeights.medium};
  ${fontSize(18)};
  line-height: 1.5;

  ${minBreakpointQuery.small`
    ${fontSize(20)};
    margin-top: 25px;
  `}
`;

const StyledDate = styled.p`
  margin-top: auto;
  padding-top: 40px;

  ${minBreakpointQuery.small`
    padding-top: 45px;
  `}

  ${minBreakpointQuery.large`
    padding-top: 50px;
  `}
`;

const BlogCard = blogPost => {
  const { title, featuredImage, category, meta, isBlogListing } = blogPost;

  return (
    <StyledBlogCard>
      <Link to={blogPost}>
        <StyledItem>
          <StyledImage
            image={featuredImage.gatsbyImageData}
            alt={featuredImage.alt}
          />
          <StyledContent>
            <StyledOverline>{category.name}</StyledOverline>
            <StyledHeading as={isBlogListing && 'h2'}>{title}</StyledHeading>
            <StyledDate>
              <time datetime={meta.fullDate}>{meta.displayDate}</time>
            </StyledDate>
          </StyledContent>
        </StyledItem>
      </Link>
    </StyledBlogCard>
  );
};

export default BlogCard;

export const BlogFragment = graphql`
  fragment BlogFragment on DatoCmsBlog {
    title
    featuredImage {
      gatsbyImageData(width: 804, height: 452)
      alt
    }
    category {
      name
    }
    meta {
      displayDate: createdAt(formatString: "Do MMM YYYY")
      fullDate: createdAt
    }
    ...LinkFragment
  }
`;
